import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const BatchIdCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Batch ID",
    cell: (row) => {
      return row.prettyBatchId ?? "";
    },
  };
